import { Icon } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import Typography from '@material-ui/core/Typography';
import { Button, IconButton } from '@mui/material';
import { closeModal } from 'app/auth/store/userSlice';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { api } from 'hooks/api/main-request/base';
import { useToast } from 'hooks/useToast';
import JWTLoginTab from './tabs/JWTLoginTab';
import WarningModal from '../apps/products/rollbacks/WarningModal';

const useStyles = makeStyles(theme => ({
	root: {
		height: '100%',
		background: `linear-gradient(to right, ${theme.palette.primary.dark} 0%, ${darken(
			theme.palette.primary.dark,
			0.5
		)} 100%)`,
		color: theme.palette.primary.contrastText
	},
	leftSection: {},
	rightSection: {
		background: `linear-gradient(to right, ${theme.palette.primary.dark} 0%, ${darken(
			theme.palette.primary.dark,
			0.5
		)} 100%)`,
		color: theme.palette.primary.contrastText
	}
}));

function Login(props) {
	const [openWarnModal, setOpenWarnModal] = useState(false);
	const classes = useStyles();
	const dispatch = useDispatch();
	const { showToast } = useToast();

	const clearLocalStorageAndCookie = async () => {
		try {
			await api.get('clear-cookie');
			localStorage.clear();
			sessionStorage.clear();
			setOpenWarnModal(false);
			showToast('Кеш успешно очищен!');
			window.location.reload();
		} catch (error) {
			console.error('Error clearing local storage and cookies:', error);
			showToast('Ошибка при очистке кеша. Пожалуйста, попробуйте еще раз.', 'error');
			setOpenWarnModal(false);
		}
	};

	return (
		<div
			className={clsx(
				classes.root,
				'flex flex-col flex-auto items-center justify-center flex-shrink-0 p-16 md:p-24'
			)}
		>
			{props?.isModal && (
				<div style={{ position: 'absolute', top: 50, left: 50 }}>
					<IconButton color="inherit" size="large" onClick={() => dispatch(closeModal())}>
						<Icon>keyboard_backspace</Icon>
					</IconButton>
				</div>
			)}

			<motion.div
				initial={{ opacity: 0, scale: 0.6 }}
				animate={{ opacity: 1, scale: 1 }}
				// max-w-400 md:max-w-3xl rounded-20 shadow-2xl
				className="flex w-full justify-center overflow-hidden"
			>
				<Card
					className={clsx(
						classes.leftSection,
						'flex flex-col w-full max-w-sm items-center justify-center rounded-20 shadow-2xl relative'
					)}
					square
				>
					<Button
						onClick={() => setOpenWarnModal(true)}
						style={{ position: 'absolute', top: 10, right: 10 }}
						color="inherit"
						variant="outlined"
					>
						Oчистить кеш
					</Button>
					<CardContent className="flex flex-col items-center justify-center w-full py-96 max-w-320">
						<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 0.2 } }}>
							<div className="flex items-center mb-48">
								<img
									className="logo-icon w-full"
									src="assets/images/logos/kittek-group.png"
									alt="logo"
								/>
							</div>
						</motion.div>

						<JWTLoginTab />
					</CardContent>

					{/* <div className="flex flex-col items-center justify-center pb-32">*/}
					{/*	<div>*/}
					{/*		<span className="font-normal">Powered by </span>*/}
					{/*		<a*/}
					{/*			className="font-normal"*/}
					{/*			target="_blank"*/}
					{/*			rel="noopener noreferrer"*/}
					{/*			href="https://albison.uz"*/}
					{/*		>*/}
					{/*			Albison*/}
					{/*		</a>*/}
					{/*	</div>*/}
					{/* </div>*/}
				</Card>

				{/* <div className={clsx(classes.rightSection, 'hidden md:flex flex-1 items-center justify-center p-64')}>
					<div className="max-w-320">
						<motion.div
							initial={{ opacity: 0, y: 40 }}
							animate={{ opacity: 1, y: 0, transition: { delay: 0.2 } }}
						>
							<Typography variant="h3" color="inherit" className="font-semibold leading-tight">
								Welcome <br />
								to the <br /> Hofmann Warehouse!
							</Typography>
						</motion.div>

						<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 0.3 } }}>
							<Typography variant="subtitle1" color="inherit" className="mt-32">
								Hofmann is a modern, affordable brand that develops and offers you branded home
								appliances for your home.
							</Typography>
						</motion.div>
					</div>
				</div> */}
			</motion.div>
			<WarningModal
				handleClose={() => setOpenWarnModal(false)}
				open={openWarnModal}
				handleOk={clearLocalStorageAndCookie}
			/>
		</div>
	);
}

export default Login;
